import { useEffect, useState } from 'react'
import { ModalStore } from '../../state/ModalStore'
import ModalContent from './ModalContent'
import ModalContentWrapper from './ModalContentWrapper'
import ModalFooter from './ModalFooter'
import ModalHeader from './ModalHeader'
import ModalMainWrapper from './ModalMainWrapper'

const FONT_SAMPLE_TEXT = 'Hi Richard, I hope this letter finds you well.'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const getFontClass = (value) => {
    const normalized = String(value || '').toLowerCase()

    if (normalized.includes('phoenix')) return 'font-phoenix'
    if (normalized.includes('hartford')) return 'font-hartford'
    if (normalized.includes('albany')) return 'font-albany'
    if (normalized.includes('boston')) return 'font-boston'
    if (normalized.includes('columbus')) return 'font-columbus'
    if (normalized.includes('denver')) return 'font-denver'
    if (normalized.includes('richmond')) return 'font-richmond'
    if (normalized.includes('seattle')) return 'font-seattle'
    if (normalized.includes('trenton')) return 'font-trenton'
    if (normalized.includes('print')) return 'font-print'
    if (normalized.includes('cursive')) return 'font-cursive'

    return ''
}

export default function FontStyleModal({
    item,
    title = 'Font Style',
    getValues,
    setValue,
    afterSelection,
}) {
    const skimModal = ModalStore((state) => state.skim)
    const [selected, setSelected] = useState(getValues(item.name) || '')

    useEffect(() => {
        setSelected(getValues(item.name) || '')
    }, [getValues, item.name])

    const handleConfirm = () => {
        if (!selected) return
        setValue(item.name, selected)
        afterSelection?.(selected)
        skimModal()
    }

    const handleSelect = (value) => {
        setSelected(value)
    }

    return (
        <ModalMainWrapper>
            <ModalContentWrapper size="3xl" spacing="normal">
                <ModalHeader title={title} />
                <ModalContent spacing="normal" scroll={true}>
                    <div className="space-y-4">
                        <p className="text-sm leading-6 text-gray-500">
                            Each letter is written in a handwriting style. Here
                            is how your message will look.
                        </p>
                        <div className="grid gap-3">
                            {item.options.map((option) => (
                                <button
                                    key={option}
                                    type="button"
                                    onClick={() => handleSelect(option)}
                                    className={classNames(
                                        selected === option
                                            ? 'border-[#F28230] shadow-[0_0_0_3px_rgba(242,130,48,0.16)]'
                                            : 'border-[#E1DACE]',
                                        'rounded-xl border-[1.5px] bg-white px-4 py-3 text-left transition-all duration-150 hover:border-[#F6D9C2]',
                                    )}>
                                    <div
                                        className={classNames(
                                            getFontClass(option),
                                            'text-[22px] leading-[1.3] text-[#2748B8]',
                                        )}>
                                        {FONT_SAMPLE_TEXT}
                                    </div>
                                    <div className="mt-2 text-xs font-semibold uppercase tracking-[0.04em] text-gray-500">
                                        {option}
                                    </div>
                                </button>
                            ))}
                        </div>
                    </div>
                </ModalContent>
                <ModalFooter
                    confirmText="Select font"
                    onConfirm={handleConfirm}
                />
            </ModalContentWrapper>
        </ModalMainWrapper>
    )
}
